import PedidoInfoPanel from "./PedidoInfoPanel";
import TableWithPagination from "./../common/TableWithPagination";


const columnasDetalles = [
  { header: 'Posición', accessor: 'docPosicion' },
  { header: 'Tipo Doc.', accessor: 'tipoDocumento' },
  { header: 'Producto', accessor: 'producto' },
  { header: 'U. Medida', accessor: 'unidadMedida' },
  { header: 'Lote', accessor: 'lote' },
  { header: 'Centro', accessor: 'centro' },
  { header: 'Cantidad', accessor: 'cantidad' },
  { header: 'F. Transporte', accessor: 'fechaTransporte' },
  { header: 'Clase Cond.', accessor: 'claseCondicion' },
  { header: 'Importe', accessor: 'importe' },
  { header: 'Moneda', accessor: 'moneda' },
  { header: 'U. Venta', accessor: 'unidadVenta' }
];


export default function PedidoDetalle({
  pedido,
  onBack,
  loading
}) {
  return (
    <div className="grid grid-cols-12 gap-5">
      <div className="xl:col-span-12 col-span-12">
        <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
                <button
                    onClick={onBack}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-700 transition"
                >
                    ← Volver a la lista
                </button>

                <h2 className="text-xl font-semibold text-slate-800 text-end">
                    Referencia: {pedido?.clienteReferencia || 'Detalle del pedido'}
                </h2>
                </div>


            {loading ? (
              <p className="text-slate-500 ">Cargando detalles...</p>
            ) : (
              <div className="space-y-4">
                
                <PedidoInfoPanel pedido={pedido} />
                <div>
                  <h3 className="text-lg font-semibold text-slate-800 dark:text-white mt-4 mb-2">Detalles:</h3>
                  {pedido?.detalles?.length > 0 ? (
                    <>
                    {/* Puedes mostrar datos generales aquí */}

                    <div>
                    <h3 className="text-lg font-medium mb-2 text-slate-700">Detalles del pedido</h3>
                        <div className="overflow-x-auto w-full">
                        <TableWithPagination
                        columns={columnasDetalles}
                        data={pedido.detalles}
                        showView={false}
                        showEdit={false}
                        showDelete={false}
                        />
                        </div>
                    </div>
                </>
                  ) : (
                    <p className="text-slate-500">No hay productos en el pedido.</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
